import React, {
  FC,
  memo,
  useEffect,
  useState,
} from "react";
import "./Search.scss";
import { StringField, CheckboxField } from "../../../../types/types";
import { documentService } from '../../../../utils/window.utils.js';

export interface SearchProps {
  searchPage: StringField;
  hideSearch: CheckboxField;
  searchLabel: StringField;
}

const Search: FC<SearchProps> = memo(({ searchPage, hideSearch, searchLabel }) => {
  const link = searchPage?.value?.["href"];
  const hide = hideSearch?.value;
  const labelSearch = searchLabel?.value;

  let urlParams;
  if (typeof window !== "undefined") {
    urlParams = new URLSearchParams(window?.location?.search ?? '');
  }
  let queryText;
  if (urlParams != undefined) {
    queryText =
      urlParams.get("q") != undefined && urlParams.get("q") != ""
        ? urlParams.get("q")
        : "";
  }
  let type;
  if (urlParams != undefined) {
    type =
      urlParams.get("type") != undefined && urlParams.get("type") != ""
        ? urlParams.get("type")
        : "";
  }
  let pageID;
  if (urlParams != undefined) {
    pageID =
      urlParams.get("pageID") != undefined && urlParams.get("pageID") != ""
        ? urlParams.get("pageID")
        : "";
  }

  const [qT, setValue] = useState("");
  const handleChangeHeader = (e) => setValue(e.target.value);

  useEffect(() => {
    if (documentService()) {
      if (qT.length > 0) {
        documentService().getElementById("searchInputCrossSvgHeader").style.display =
          "block";
          documentService().getElementById("search-value").style.display = "none";
      } else {
        documentService().getElementById("searchInputCrossSvgHeader").style.display = "none";
        documentService().getElementById("search-value").style.display = "block";
      }
    }
  }, [qT]);

  const onInputSearchKeyupHeader = (e) => {
    if (e.keyCode == "13") {
      searchSitecoreHeader();
      setValue("");
    }
  };

  const searchSitecoreHeader = () => {
    const currentPage = 1;
    const itemPerPage = 10;
    const valSearch = (
      document && document.getElementById("searchFieldsetInputHeader") as HTMLInputElement
    )?.value;
    if (valSearch && valSearch != "") {
      let redirectUrl = "";
      if (type && type != "" && pageID && pageID != "") {
        redirectUrl = `${link}?q=${valSearch}&type=${type}&pageID=${pageID}`;
      } else {
        redirectUrl = `${link}?q=${valSearch}&page=${currentPage}&take=${itemPerPage}`; //&filters=Vehicles
      }
      if (typeof window !== "undefined") {
        window.location.href = redirectUrl;
      }
    }
  };

  const clearInputSearchHeader = () => {
    setValue("");
  };

  return (
    <>
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, maximum-scale=1"
      ></meta>
      <section className={"search-module-header"} 
        style={{ display: hide ? "none" : "block" }}>
        <div className={"content-main search-content"}>
          <div className="search-fieldset-wrapper">
            <fieldset className="search-fieldset-header" id="searchFieldset">
              <input
                id="searchFieldsetInputHeader"
                type="text"
                className="search-fieldset-input"
                value={qT}
                onKeyUp={onInputSearchKeyupHeader}
                onChange={handleChangeHeader}
              />
              <label id="search-value">{labelSearch}</label>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="search-input-lens-svg"
                onClick={searchSitecoreHeader}
              >
                <path
                  d="M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17Z"
                  stroke="#14181F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15 15L21 21"
                  stroke="#14181F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                className="search-input-cross-svg"
                id="searchInputCrossSvgHeader"
                onClick={clearInputSearchHeader}
              >
                <path
                  d="M16 16L8 8"
                  stroke="#14181F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M16 8L8 16"
                  stroke="#14181F"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </fieldset>
          </div>
        </div>
      </section>
    </>
  );
});

export default Search;
